import { TStorage } from '../../types';
import { API_URL } from '../api';

export const getMediaLink = (fileName: string, storageType: TStorage) => {
  return `${API_URL}/storage/${storageType}/${fileName}`;
};
